<template lang="pug">
  .layout.d-flex.clickable
    div
      y-checkbox.mb-n2(v-model="checkbox")
    div.d-flex(v-if="title")
      div.h6.basic700--text.ml-1 {{ title }}
      div.p1.basic600--text.ml-2(style="margin-top: 2px;") {{ leads.length }}
    v-spacer(v-if="title")
    v-menu(v-if="selectedLeads.length > 0" right :offset-y='true')
      template(v-slot:activator='{ on }')
        .bulk.d-flex(v-on="on")
          .button-Aa-small.mt-1 Bulk action ({{ selectedLeads.length }})
          eva-icon.mb-n1(name="chevron-down-outline" width="20" height="20" style="margin-top: 2px" :fill="$vuetify.theme.themes[$theme].basic700")
      v-list(dense)
        v-list-item(@click="clickValidations(actions.PICK_LIST)")
          v-list-item-title.s2.basic800--text {{ $t('view_pick_list') }}
        v-divider.basic300
        v-menu(right :offset-x='true')
          template(v-slot:activator='{ on }')
            v-list-item(v-on="on")
              v-list-item-title.s2.basic800--text {{ $t('update_status') }}
              v-list-item-icon.mr-n3
                eva-icon.mb-n1(name="chevron-right-outline" width="24" height="24" style="margin-top: 2px" :fill="$vuetify.theme.themes[$theme].basic700")
          v-list.pa-0(dense)
            v-list-item(v-for="status in statuses" :key="status.value" @click="updateToStatus = status; clickValidations(actions.UPDATE_ORDER_STATUS)")
              v-list-item-title.s2.basic800--text {{ status.text }}
        template(v-if="$currency.code === 'MYR'")
          .arrange-shipment(v-if="$store.state.orders.selectedTab == 0 && (shipments.easyparcel || shipments.lalamove)")
            v-divider.basic300
            v-menu(right :offset-x='true')
              template(v-slot:activator='{ on }')
                v-list-item(v-on="on")
                  v-list-item-title.s2.basic800--text {{ $t('arrange_shipment') }}
                  v-list-item-icon.mr-n3
                    eva-icon.mb-n1(name="chevron-right-outline" width="24" height="24" style="margin-top: 2px" :fill="$vuetify.theme.themes[$theme].basic700")
              v-list.pa-0(dense)
                v-list-item(v-if="shipments.lalamove" @click="shipToCourier = couriers.LALAMOVE; clickValidations(actions.SHIP_ORDER_TO_COURIER)")
                  v-list-item-action-text.mr-2
                    v-img(:src="require('@/assets/images/icon_lalamove.png')" width="20px")
                  v-list-item-content
                    v-list-item-title
                      .s2.basic800--text| {{ $t('export_lalamove') }}
                v-list-item(v-if="shipments.easyparcel" @click="shipToCourier = couriers.EASYPARCEL; clickValidations(actions.SHIP_ORDER_TO_COURIER)")
                  v-list-item-action-text.mr-2
                    v-img(:src="require('@/assets/images/logo_easyparcel_small.png')" width="20px")
                  v-list-item-content
                    v-list-item-title
                      .s2.basic800--text| Easyparcel
          .ys-arrange-shipment(v-if="$store.state.orders.selectedTab == 0 && (shipments.yscourier || shipments.yslocaldelivery)")
            v-divider.basic300
            v-list-item(@click="clickValidations(actions.SHIP_ORDER_TO_YEZZA_SHIPPING)")
              v-list-item-title.s2.basic800--text {{ $t('arrange_shipment') }}
        .riders(v-if="$store.state.orders.selectedTab == 0 && showSendToRider")
          v-divider.basic300
          v-list-item(@click="clickValidations(actions.SEND_ORDER_TO_RIDER)")
            v-list-item-title.s2.basic800--text {{ $t('send_order_details_to') }}
        v-divider.basic300
        v-list-item(@click="clickValidations(actions.DOWNLOAD_SHIPPING_DOCUMENT)")
          v-list-item-title.s2.basic800--text {{ $t('download_shipping_documents') }}
        v-divider.basic300
        v-list-item(@click="clickValidations(actions.EXPORT_ORDERS_TO_EXCEL)")
          v-list-item-title.s2.basic800--text {{ $t('export_orders_to_excel') }}
    
    .modals
      pick-list-dialog(v-if="showViewPickListDialog" :open.sync="showViewPickListDialog" :leads.sync="selectedLeads")
      rider-list(v-if="openRiderListDialog" :open.sync="openRiderListDialog" :leads.sync="selectedLeads")
      bulk-ship-item(v-if="openBulkShipItemDialog" :open.sync="openBulkShipItemDialog" :parentLeads.sync="selectedLeads" @order-submitted="handleOrdersSubmitted")
      bulk-arrange-shipment(v-if="openBulkArrangeShipmentDialog" :open.sync="openBulkArrangeShipmentDialog" :parentLeads.sync="selectedLeads"  @refetchLead="handleOrdersSubmitted" @closeDialog="showModal = false")
      y-dialog(v-if="openUpdateStatusDialog" v-model='openUpdateStatusDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('update_status') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('update_status_confirmation') }}
              strong  {{ updateToStatus.text }}
              span  ?
          v-card-actions
            v-spacer
            v-btn(color='white', text @click="openUpdateStatusDialog = false")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' depressed height=32 @click='startUpdateStatus' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('update') }}
      y-dialog(fill-height fluid v-model="showDownloadDocumentsDialog" transition="fade-transition" scrollable persistent max-width="400px")
        v-card
          v-card-title
            .s1 {{ $t('download_shipping_documents') }}
            .c1.basic600--text {{ $t('shipping_documents_for') }}
              span.font-weight-bold  {{ selectedLeads.length }}
              span  {{ $t('selected_orders') }}
          v-card-text.pb-3
            div.d-flex.clickable.mt-3(v-for="document in documents" :key="document.value")
              div
                y-checkbox.mb-n2(v-model="document.selected" :color="$vuetify.theme.themes[$theme].info500" @change="resetSelected(document)")
              .p2 {{ document.text }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showDownloadDocumentsDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="downloadDocuments()")
              .button-AA-small.basic100--text {{ $t('download') }}
      y-dialog(fill-height fluid v-model="showInvalidLeadsDialog" transition="fade-transition" scrollable persistent max-width="400px")
        v-card
          v-card-title
            div.pa-0(v-if="currentAction === actions.SHIP_ORDER_TO_YEZZA_SHIPPING")
              .s1.danger500--text {{ $t('invalid_order') }}
              .c1.basic600--text.mt-1 {{ $t('cant_bulk_arrange_shipment') }}
              .c1.basic600--text.mt-1 {{ $t('try_filtering_your_orders') }}
              .c1.basic600--text.mt-1 {{ $t('contains') }}
                span.font-weight-bold  {{ invalidLeads.length }}
                span  {{ $t('mix_orders_for') }}
            div.pa-0(v-else)
              .s1.danger500--text {{ $t('invalid_order') }}
              .c1.basic600--text {{ $t('contains') }}Contains
                span.font-weight-bold  {{ invalidLeads.length }}
                span  {{ $t('invalid_orders_for_this') }}
          v-divider.basic300
          v-card-text.pb-3
            template(v-for="(lead, index) in invalidLeads")
              v-list-item.pa-0.mb-n3(:key="lead.id")
                v-list-item-title
                  .s2.basic1000--text # {{ lead.rid }} {{ lead.created | convertServerDate }}
                v-list-item-action.my-0
                  v-btn(icon @click="clearLead(lead)")
                    v-icon(color="danger") mdi-close-circle
          v-divider.basic300
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showInvalidLeadsDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clearInvalidLeads()")
              .button-AA-small.basic100--text {{ $t('clear_and_proceed') }}

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import PickListDialog from '@/components/ordermgmt/PickListDialog.vue'
import RiderList from '@/components/dialogs/order/RiderList.vue'
import BulkShipItem from '@/components/dialogs/order/BulkShipItem.vue'
import BulkArrangeShipment from '@/components/dialogs/yezzashipping/BulkArrangeShipment.vue'

let asyncForEach = async function (array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export default {
  name: 'BulkOrderActions',
  props: ['leads', 'title'],
  components: { PickListDialog, RiderList, BulkShipItem, BulkArrangeShipment },
  data: () => ({
    showViewPickListDialog: false,
    showDownloadDocumentsDialog: false,
    openRiderListDialog: false,
    openBulkShipItemDialog: false,
    openBulkArrangeShipmentDialog: false,
    showInvalidLeadsDialog: false,
    openUpdateStatusDialog: false,
    updateToStatus: {},
    shipToCourier: '',
    currentAction: '',
    documents: [
      { text: 'Pick list (PDF)', value: 'pick_list_pdf', selected: false, file_name: 'pick_list', internal: true, path: 'print-pick-list'},
      { text: 'Pick list (Excel)', value: 'pick_list_excel', selected: false, file_name: 'pick_list', internal: false, path: 'pick_list_export_csv'},
      { text: 'Packing slip (PDF)', value: 'packing_slip_pdf', selected: false, file_name: 'packing_slip', internal: true, path: 'print-packing-slips' },
    ],
    couriers: {
      LALAMOVE: 'lalamove',
      EASYPARCEL: 'easyparcel'
    },
    actions: {
      PICK_LIST: 'pick_list',
      SEND_ORDER_TO_RIDER: 'send_order_to_rider',
      SHIP_ORDER_TO_COURIER: 'ship_order_to_courier',
      SHIP_ORDER_TO_YEZZA_SHIPPING: 'ship_order_to_yezza_shipping',
      DOWNLOAD_SHIPPING_DOCUMENT: 'download_shipping_document',
      UPDATE_ORDER_STATUS: 'update_order_status',
      EXPORT_ORDERS_TO_EXCEL: 'export_orders_to_excel',
    },
    invalidLeads: [],
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany',
      selectedLeads: 'orders/getSelectedLeads',
      shipments: 'orders/getShipments',
    }),
    checkbox: {
      get () {
        if (this.leads.length === 0) {
          return false
        }
        let hasMissing = false
        this.leads.forEach(lead => {
          if (!this.selectedLeads.filter(f => f.id === lead.id)[0]) {
            hasMissing = true
          }
        })
        if (hasMissing) {
          return false
        }
        return true
      },
      set (val) {
        if (val) {
          this.leads.forEach(lead => {
            if (!this.selectedLeads.filter(f => f.id === lead.id)[0]) {
              this.$store.commit('orders/addLead', lead)
            }
          })
        } else {
          this.leads.forEach(lead => {
            this.$store.commit('orders/deleteLead', lead)
          })
        }
      }
    },
    leadIds () {
      return this.selectedLeads.map(m => m.id).join()
    },
    statuses() {
      let items = []
      const tab = this.$store.state.orders.selectedTab
      if (tab == 0) {
        items = [
          { text: 'Processing', value: 'not-ready' },
          { text: 'Ready', value: 'ready' },
          { text: 'Shipped', value: 'shipped' },
          { text: 'Delivered', value: 'received' },
        ]
      } else if (tab == 1) {
        items = [
          { text: 'Processing', value: 'processed' },
          { text: 'Delivered', value: 'received' },
        ]
      } else if (tab == 2) {
        items = [
          { text: 'Processing', value: 'processed' },
          { text: 'Shipped', value: 'shipped' },
        ]
      }
      return items
    },
    showSendToRider () {
      if (this.selectedLeads.filter(f => !f.shipping).length > 0) {
        return false
      } else {
        let shippingMethods= this.selectedLeads.map(m => m.shipping.shipping_method)
        if (shippingMethods.some(s => s !== 'manual')) {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    resetSelected (selectedDoc) {
      this.documents.forEach((doc, index) => {
        if (selectedDoc.value != doc.value) {
          this.documents[index].selected = false
        }
      })
    },
    clickViewPickList () {
      this.showViewPickListDialog = true
    },
    async startUpdateStatus () {
      this.isLoading = true
      await asyncForEach(this.selectedLeads, async (lead) => {
        try {
          let data = { status: this.updateToStatus.value }
          if (this.updateToStatus.value === 'ready') {
            await this.$axios.put(`/leads/${lead.pid}/taggings/ready`)
          } else if (this.updateToStatus.value === 'not-ready') {
            await this.$axios.delete(`/leads/${lead.pid}/taggings/ready`)
          } else {
            await this.axios.patch(`/leads/${lead.pid}/`, data)
          }
        } catch { /* continue regardless of error */ }
      })
      this.isLoading = false
      this.openUpdateStatusDialog = false
      this.$store.commit('orders/resetLeads', true)
    },
    clickDownloadShipingDocument() {
      this.showDownloadDocumentsDialog = true
    },
    downloadDocuments () {
      const selectedDocuments = this.documents.filter(f => f.selected)
      if (selectedDocuments.length == 0) {
        this.showMessage(['error', this.$t('error_message.no_options_selected')])
        return
      }
      if (selectedDocuments.length == 1) {
        const selectedDocument = selectedDocuments[0]
        if (selectedDocument.internal) {
          this.$axios.post(`/users/${this.user.id}/request_otk/`)
            .then(response => {
              const data = {
                company_name: this.company.name,
                company_id: this.company.id,
                key: response.data.key,
                leadPids: this.selectedLeads.map(m => { return m.pid}),
              }
              this.startDownloadPDFDocument(selectedDocument, data)
            }).catch(() => {})
        } else {
          const exportUrl = `/leads/${selectedDocument.path}/?company=${this.company.id}&lead_ids=${this.leadIds}`
          this.startDownloadFileFromUrl(exportUrl)
        }
        return
      }
      // selectedDocuments.forEach(doc => {
      //   this.startDownloadDocument(doc)
      // })
    },
    startDownloadFileFromUrl (exportUrl) {
      let exportDomain = 'https://export-test.yezza.io'
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          exportUrl = exportDomain + exportUrl
          exportUrl += `&key=${response.data.key}`
          if (this.$isMobile) {
            window.open(exportUrl)
          } else {
            location.href = exportUrl
          }
        }).catch(() => {})
    },
    exportLalamove () {
      const exportUrl = `/shipping/shippings/export_fulfillment/?company=${this.company.id}&leads=${this.leadIds}&provider=lalamove`
      this.startDownloadFileFromUrl(exportUrl)
    },
    startDownloadPDFDocument (doc, data) {
      const dataString = btoa(JSON.stringify(data))
      let printUrl = `https://pdf.yezza.io/?url=http://localhost:8080/${doc.path}/${dataString}`
      if (this.$subdomain) {
        printUrl = `https://pdf.yezza.io/?url=${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/${doc.path}/${dataString}`
      }
      printUrl += `&type=pdf&filename=${doc.file_name}.pdf&waitUntil=networkidle0&printBackground=true&format=A4`
      if (this.$isMobile) {
        window.open(printUrl)
      } else {
        location.href = printUrl
      }
    },
    clickSendOrderToRider () {
      this.openRiderListDialog = true
    },
    clickExportOrderToExcel() {
      const exportUrl = `/leads/export_csv/?company=${this.company.id}&ids=${this.leadIds}`
      this.startDownloadFileFromUrl(exportUrl)
    },
    clickValidations(action) {
      if (this.selectedLeads.length > 100) {
        this.showMessage(['error', this.$t('error_message.max_hundred_orders')])
        return
      }
      this.showInvalidLeadsDialog = false
      this.currentAction = action
      if (action === this.actions.PICK_LIST) {
        this.clickViewPickList()
      }
      else if (action === this.actions.UPDATE_ORDER_STATUS) {
        this.openUpdateStatusDialog = true
      }
      else if (action === this.actions.SEND_ORDER_TO_RIDER) {
        this.clickSendOrderToRider()
      }
      else if (action === this.actions.DOWNLOAD_SHIPPING_DOCUMENT) {
        this.clickDownloadShipingDocument()
      }
      else if (action === this.actions.SHIP_ORDER_TO_COURIER) {
        if (!this.company.address) {
          this.showMessage(['error', this.$t('error_message.please_fill_company_address')])
          return
        }
        if (this.shipToCourier === this.couriers.LALAMOVE) {
          if (this.selectedLeads.length > 19) {
            this.showMessage(['error', this.$t('error_message.max_orders_in_export', { count: 19 })])
            return
          }
          this.exportLalamove()
        } else if (this.shipToCourier === this.couriers.EASYPARCEL) {
          this.invalidLeads = []
          this.selectedLeads.forEach(lead => {
            if (!this.isValidLeadForEasyparcel(lead)) {
              this.invalidLeads.push(lead)
            }
          })
          if (this.invalidLeads.length > 0) {
            this.showInvalidLeadsDialog = true
            return
          }
          if (this.selectedLeads.length == 0) {
            this.showMessage(['error', this.$t('error_message.select_one_order')])
            return
          }
          this.openBulkShipItemDialog = true
        }
      }
      else if (action === this.actions.SHIP_ORDER_TO_YEZZA_SHIPPING) {
        this.invalidLeads = []
        let courier = []
        let local = []
        this.selectedLeads.forEach(lead => {
          if (lead.shipping && ['ys_localdelivery', 'ys_courier', 'manual'].includes(lead.shipping.shipping_method)) {
            if (lead.shipping.shipping_method === 'ys_localdelivery') {
              local.push(lead)
            } else if (lead.shipping.shipping_method === 'ys_courier') {
              courier.push(lead)
            } else if (lead.shipping.shipping_method === 'manual' && lead.shipping.fulfilment_type === 'courier') {
              courier.push(lead)
            } else if (lead.shipping.shipping_method === 'manual' && lead.shipping.fulfilment_type === 'local_delivery') {
              local.push(lead)
            }
          } else {
            this.invalidLeads.push(lead)
          }
        })
        let selectMethod = Math.max(courier.length, local.length)
        if (courier.length === selectMethod) {
          this.invalidLeads = this.invalidLeads.concat(local)
        } else if (local.length === selectMethod) {
          this.invalidLeads = this.invalidLeads.concat(courier)
        }
        if (this.invalidLeads.length > 0) {
          this.showInvalidLeadsDialog = true
          return
        }
        if (this.selectedLeads.length == 0) {
          this.showMessage(['error', this.$t('error_message.select_one_order')])
          return
        }
        if (this.selectedLeads.length > 20) {
          this.showMessage(['error', this.$t('error_message.max_orders_in_export', { count: 20 })])
          return
        }
        this.openBulkArrangeShipmentDialog = true
      }
      else if (action === this.actions.EXPORT_ORDERS_TO_EXCEL) {
        this.clickExportOrderToExcel()
      }
    },
    isValidLeadForEasyparcel (lead) {
      if (!lead.shipping) {
        return true
      } else if (['easyparcel', 'manual'].includes(lead.shipping.shipping_method) && (lead.shipping.status == 'new' || lead.shipping.status == 'error')) {
        return true
      }
      return false
    },
    clearLead (lead) {
      this.$store.commit('orders/deleteLead', lead)
      this.invalidLeads = this.invalidLeads.filter(f => f.id !== lead.id)
      if (this.invalidLeads.length === 0 && this.selectedLeads.length > 0) {
        this.clickValidations(this.currentAction)
      }
    },
    clearInvalidLeads () {
      this.invalidLeads.forEach(lead => {
        this.$store.commit('orders/deleteLead', lead)
      })
      this.invalidLeads = []
      this.clickValidations(this.currentAction)
      if (this.invalidLeads.length === 0 && this.selectedLeads.length > 0) {
        this.clickValidations(this.currentAction)
      }
    },
    handleOrdersSubmitted () {
      this.$store.commit('orders/resetLeads', true)
    }
  }
}
</script>

<style scoped>
.order-title:hover{
  text-decoration: underline;
  cursor: pointer;
}
.border-bottom{
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>

<i18n>
{
  "en": {
    "view_pick_list": "View pick list",
    "update_status": "Update status",
    "arrange_shipment": "Arrange shipment",
    "export_lalamove": "Export Lalamove",
    "send_order_details_to": "Send order details to own rider",
    "download_shipping_documents": "Download shipping documents",
    "export_orders_to_excel": "Export orders to Excel",
    "update_status": "Update Status",
    "update_status_confirmation": "Are you sure you want to change the selected customer status to",
    "clear_and_proceed" : "clear & proceed",
    "download_shipping_documents": "Download shipping documents",
    "shipping_documents_for": "Shipping documents for",
    "selected_orders": "selected orders",
    "invalid_order": "Invalid order",
    "cant_bulk_arrange_shipment": "Can’t bulk arrange shipments for courier and local delivery orders at the same time.",
    "try_filtering_your_orders": "Try filtering your orders by fulfilment method when arranging shipments in bulk.",
    "contains": "Contains",
    "mix_orders_for": "mix orders for this action",
    "invalid_orders_for_this": "invalid orders for this action"
  },
  "id": {
    "view_pick_list": "Lihat daftar order",
    "update_status": "Tukar status",
    "arrange_shipment": "Kelola pengiriman",
    "export_lalamove": "Ekspor Lalamove",
    "send_order_details_to": "Kirim detail pengiriman kepada rider",
    "download_shipping_documents": "Unduh dokumen pengiriman",
    "export_orders_to_excel": "Ekspor order ke Excel",
    "update_status": "Ubah Status",
    "update_status_confirmation": "Apakah kamu yakin ingin mengubah status pelanggan yang dipilih menjadi",
    "clear_and_proceed" : "hapus & lanjutkan",
    "download_shipping_documents": "Unduh dokumen pengiriman",
    "shipping_documents_for": "Dokumen pengiriman untuk",
    "selected_orders": "order yang dipilih",
    "invalid_order": "order tidak valid",
    "cant_bulk_arrange_shipment": "Tidak dapat mengatur pengiriman massal untuk kurir dan pesanan pengiriman lokal secara bersamaan.",
    "try_filtering_your_orders": "Coba saring pesanan kamu dengan metode pengiriman saat mengatur pengiriman dalam jumlah besar.",
    "contains": "mengandung",
    "mix_orders_for": "campur pesanan untuk tindakan ini",
    "invalid_orders_for_this": "orders tidak valid untuk tindakan ini"
  }
}
</i18n>
